import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import './style.scss';
import PRZSelect from '../../../UI/PRZSelect';

const { Option } = Select;

const TallyProductSelect = ({
  record, tallyProducts, getTallyProductsLoading, setProductMappings, productMappings, getTallyProducts,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedProductTally, setSelectedProductTally] = useState('');
  useEffect(() => {
    if (record?.tally_products) {
      getTallyProducts('', record?.tally_products?.[0]?.temp_tally_product_id);
      setSelectedProductTally(record?.tally_products?.[0]?.temp_tally_product_id);
    }
  }, []);

  useEffect(() => {
    if (searchKeyword) {
      const delayDebounceFn = setTimeout(() => {
        getTallyProducts(searchKeyword);
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchKeyword]);

  const handleSearch = (val) => {
    setSearchKeyword(val);
    setOpen(true);
  };

  const handleChange = (val) => {
    const selectedProduct = tallyProducts?.find((item) => item.temp_tally_product_id === val);
    setProductMappings((prevMappings) => {
      const productIndex = prevMappings.findIndex((product) => product.productSkuId === record.product_sku_id);
      const updatedMappings = [...prevMappings];
      updatedMappings[productIndex] = {
        ...updatedMappings[productIndex],
        tallyName: selectedProduct?.product_name,
        tallyUomName: selectedProduct?.base_unit,
        temp_tally_product_id: selectedProduct?.temp_tally_product_id,
      };
      return updatedMappings;
    });
    setSelectedProductTally(selectedProduct?.temp_tally_product_id || '');
    setOpen(false);
  };

  const handleClear = () => {
    setProductMappings((prevMappings) => {
      const productIndex = prevMappings.findIndex((product) => product.productSkuId === record.product_sku_id);
      const updatedMappings = [...prevMappings];
      updatedMappings[productIndex] = {
        ...updatedMappings[productIndex],
        tallyName: '',
        tallyUomName: '',
      };
      return updatedMappings;
    });
    setSearchKeyword('');
    setOpen(false);
  };

  return (
    <div className="tally-product-selector-wrapper">
      <PRZSelect
        value={selectedProductTally}
        showSearch
        onSearch={handleSearch}
        searchValue={searchKeyword}
        allowClear
        filterOption={false}
        placeholder="Search product.."
        onChange={handleChange}
        onClear={handleClear}
        size="small"
        open={open}
        onDropdownVisibleChange={(isOpen) => setOpen(isOpen)}
        style={{
          width: '250px',
          outline: 'none',
        }}
        loading={getTallyProductsLoading}
        disabled={getTallyProductsLoading}
      >
        {tallyProducts?.map((item) => (
          <Option key={item?.temp_tally_product_id} value={item?.temp_tally_product_id}>
            {item.product_name}
          </Option>
        ))}
      </PRZSelect>
    </div>
  );
};

export default TallyProductSelect;
